import React, { useState } from 'react'
import { Alert, Typography, Input, Button, Icon } from 'components'
import { useNavigate } from 'react-router-dom'
import { ROUTES, URL_CONST } from 'constants/urls'
import { CodeResponseStorage } from './components/types/responses'
import { sendCodeRequest } from 'services/forgetPassword'
import * as S from './styles'
import { toast } from 'react-toastify'
import { AuthLayout } from 'layouts/AuthLayout'
import { theme } from 'styles/theme/hav-theme'

const { forgetPassword } = ROUTES

const SendEmailForm: React.FC = () => {
  const [email, setEmail] = useState<string>('')
  const [showEmailError, setShowEmailError] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowEmailError(false)
    const { value } = e.target
    setEmail(value)
  }

  // TODO: Remove comment when email domain validation is enabled
  // const isInvalidDomainEmail =
  //   !isDevelopment && !isValidDomainEmail(email) && email !== ''

  const hasFormError = () => {
    return email === '' // || isInvalidDomainEmail // TODO: Remove comment when email domain validation is enabled
  }

  const handleSendCodeValidation = async (event: React.FormEvent) => {
    event.preventDefault()
    setLoading(true)
    try {
      // envio de e-mail de validação
      const response = await sendCodeRequest({
        ds_emai: email
      })

      const { return_code } = response

      // NOTE: Email tied to another profile
      if (return_code === 6012) {
        setShowEmailError(true)
        return
      }
      // NOTE: Email not found in database
      if (return_code === 11) {
        toast.error('Email não registrado. Contate o backoffice para mais informações.')
        return
      }

      const composeStorage: CodeResponseStorage = {
        id_usua: response.id_usua,
        nm_usua: response?.nm_usua || '',
        return_code: response.return_code,
        return_chav: response.return_chav,
        email: email
      }
      localStorage.setItem('resetPassword', JSON.stringify(composeStorage))
      setLoading(false)
      setShowEmailError(false)
      navigate(forgetPassword.getLink('validateCode'))
    } catch (error) {
      toast.error('Erro ao enviar código de validação')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout>
      <form onSubmit={handleSendCodeValidation} autoComplete="true">
        <S.FieldsWrapper>
          <Typography className="forgetTitle" design="hav-h5-text">
            Esqueceu sua senha?
          </Typography>

          <Typography className="forgetDescriptionWithoutPad">
            Preencha o campo abaixo e enviaremos um código de verificação de cadastro.
          </Typography>
          {showEmailError && (
            <S.ErrorWrapper>
              <Alert
                kind="error"
                fullWidth
                title="E-mail atrelado à outros perfis."
                message={
                  <>
                    Para resetar a sua senha ligue para <strong>(11) 3847-7477</strong>.
                  </>
                }
              />
            </S.ErrorWrapper>
          )}
          <Input
            name="cd_usua"
            value={email}
            label="Email"
            type="email"
            height={40}
            onChange={handleInputChange}
            InputProps={{
              placeholder: 'Insira seu email',
              autoFocus: true,
              inputProps: { maxLength: 100 }
            }}
            // error={isInvalidDomainEmail ? invalidEmailDomainError.description : null} // TODO: Uncomment when email domain validation is enabled
          />
        </S.FieldsWrapper>
        <S.ButtonWrapper>
          <Button
            fullWidth
            content="Enviar código"
            type="submit"
            loading={loading}
            disabled={hasFormError()}
          />
        </S.ButtonWrapper>
        <S.LinkGoBackContainer>
          <S.LinkGoBack href={URL_CONST.LOGIN}>
            <Icon icon="chevron-left" color={theme.colors.primary.main} size="15" />
            Voltar
          </S.LinkGoBack>
        </S.LinkGoBackContainer>
      </form>
    </AuthLayout>
  )
}

export default SendEmailForm
